import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  facilities: [],
  staff: [],
  workingHours: [],
  appointments: [],
  selectedFacilities: [],
  selectedStaff: [],
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setFacilities(state, action) {
      state.facilities = action.payload;
    },
    setStaff(state, action) {
      state.staff = action.payload;
    },
    setWorkingHours(state, action) {
      state.workingHours = action.payload;
    },
    setAppointments(state, action) {
      state.appointments = action.payload;
    },
    setSelectedFacilities(state, action) {
      state.selectedFacilities = action.payload;
    },
    setSelectedStaff(state, action) {
      state.selectedStaff = action.payload;
    },
  },
});

export const {
  setFacilities,
  setStaff,
  setWorkingHours,
  setAppointments,
  setSelectedFacilities,
  setSelectedStaff,
} = calendarSlice.actions;

export default calendarSlice.reducer; 